import React from 'react';
import { Redirect } from 'react-router';
import _ from 'underscore';

import { Favorites } from '../../../content/resources/Favorites';
import { Metrics } from '../../resources/Metrics';
import { RouterError } from '../../../app/spaces/RouterHelpers/RouterError';
import { SpacesSiteUrls } from '../../../app/spaces/SpacesSiteUrls';

export interface RedirectToFavoritedMetricProviderProps {
  readonly metricId: string;
  readonly urls: SpacesSiteUrls;
}

export interface RedirectToFavoritedMetricProviderState {
  readonly metricExists: boolean;
  readonly hasError: boolean;
}

const InitialState: RedirectToFavoritedMetricProviderState = {
  metricExists: false,
  hasError: false
};

export class RedirectToFavoritedMetricProvider extends React.PureComponent<RedirectToFavoritedMetricProviderProps, RedirectToFavoritedMetricProviderState> {
  private unmounted: boolean = false;

  public constructor(props: RedirectToFavoritedMetricProviderProps) {
    super(props);
    this.state = InitialState;
  }

  public render(): JSX.Element {
    if (this.state.hasError) {
      return <RouterError errorType={'metric-removed-favorite'} urls={this.props.urls} />;
    } else if (this.state.metricExists) {
      return <Redirect to={this.props.urls.metricPath(this.props.metricId)} />;
    }

    return null;
  }

  public async componentDidMount() {
    if (_.isUndefined(this.props.metricId)) {
      this.setToErrorStateAndRemoveFromFavorites();
      return;
    }

    try {
      const metricInfo = await Metrics.getById(this.props.metricId);

      if (metricInfo) {
        this.updateState({ metricExists: true });
      } else {
        this.setToErrorStateAndRemoveFromFavorites();
      }

    } catch (e) {
      this.setToErrorStateAndRemoveFromFavorites();
    }
  }

  private setToErrorStateAndRemoveFromFavorites() {
    Favorites.remove(this.props.metricId, 'metric');
    this.updateState({ hasError: true });
  }

  public componentWillUnmount() {
    this.unmounted = true;
  }

  private updateState<K extends keyof RedirectToFavoritedMetricProviderState>(newState: Pick<RedirectToFavoritedMetricProviderState, K>): void {
    if (!this.unmounted) {
      this.setState(newState);
    }
  }
}
